import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'

let Axios = axios.create({})

// 添加请求拦截器
Axios.interceptors.request.use((config) => {
  // 请求头中添加sessionStorage存储的token
  config.headers['token'] = sessionStorage.getItem('token') || ''
  return config
})

// 添加响应拦截器
Axios.interceptors.response.use((response) => {
  if (response.data.code === 103) {
    // token失效自动登出
    router.push('/login')
    Message({
      type: 'warning',
      message: '已超时，请重新登录',
      duration: 1000
    })
  } else {
    return response
  }
}, (error) => {
  Message({
    type: 'error',
    message: '服务器异常，请稍后重试',
    duration: 1000
  })
  return error
})

export default Axios



// WEBPACK FOOTER //
// ./src/apiConfig/axios.js